import { styled } from "styled-components";

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: white;
  overflow: hidden;
`;

export default ContentContainer;
